import { z } from "zod";
import zodToCamelCase from "zod-to-camel-case";

import { assetSchema } from "@/schema/public/asset/asset.schema";
import { publishedAssetObjectSchema } from "@/schema/published/components/assetObject/assetObject.schema";

export const publishedAssetsSchema = assetSchema
    .pick({
        asset_id: true,
        asset_type: true,
        asset_uid: true,
        created_at: true,
        updated_at: true,
    })
    .extend({
        // asset_object JSONB can contain null bucket entries in partially-populated assets
        asset_object: publishedAssetObjectSchema,
    });
export type PublishedAssets = z.infer<typeof publishedAssetsSchema>;

export const publishedAssetsSchemaCamel = zodToCamelCase(publishedAssetsSchema);
export type PublishedAssetsCamel = z.infer<typeof publishedAssetsSchemaCamel>;
